<template>
    <button
        v-if="visible"
        type="button"
        @click="toggle"
        :class="['theme-toggle', size === 'sm' ? 'theme-toggle--sm' : '']"
        :aria-label="isDark ? 'Cambiar a tema claro' : 'Cambiar a tema oscuro'"
        :title="isDark ? 'Tema claro' : 'Tema oscuro'"
    >
        <span class="material-symbols-outlined theme-toggle__icon" :class="isDark ? 'theme-toggle__icon--dark' : ''">
            {{ isDark ? 'dark_mode' : 'light_mode' }}
        </span>
    </button>
</template>

<script>
import { useTheme } from '@/composables/useTheme.js';
import { computed } from 'vue';

export default {
    name: 'ThemeToggle',
    props: {
        size: { type: String, default: 'md' },
    },
    setup() {
        const { theme, isDark, toggle } = useTheme();
        const visible = computed(() => {
            if (typeof window === 'undefined') return false;
            return true;
        });
        return { theme, isDark, toggle, visible };
    },
};
</script>

<style scoped>
.theme-toggle {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border-radius: 9999px;
    background: rgba(255, 255, 255, 0.6);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border: 1px solid rgba(255, 255, 255, 0.5);
    color: var(--color-m3-on-surface-variant);
    transition: transform 200ms cubic-bezier(0.34, 1.56, 0.64, 1), background-color 200ms ease;
    cursor: pointer;
}
.theme-toggle:hover {
    background: var(--color-m3-surface-container-low);
    transform: rotate(20deg);
}
.theme-toggle:active {
    transform: scale(0.92);
}
.theme-toggle--sm {
    width: 36px;
    height: 36px;
}
.theme-toggle__icon {
    font-size: 22px;
    line-height: 1;
    transition: transform 300ms cubic-bezier(0.34, 1.56, 0.64, 1);
}
.theme-toggle__icon--dark {
    color: var(--color-m3-tertiary);
}
:root[data-theme='dark'] .theme-toggle {
    background: rgba(0, 0, 0, 0.4);
    border-color: rgba(255, 255, 255, 0.1);
    color: var(--color-m3-on-primary-container);
}
</style>
